import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';  
import { Ergebnisse } from '../data/ws/ergebnis/ergebnisse.model';
import { Preisstand } from '../data/ws/dbKlassen/preisstand.model';
import { Kge } from '../data/ws/dbKlassen/kge.model';
import { UserGebaeudeFilter } from '../data/user/user-gebaeude-filter.model';
import { ModulAuspraegungPrFilter } from '../data/ws/modul/modul-auspraegung-pr-filter.model';
import { Gebaeude } from '../data/ws/dbKlassen/gebaeude.model';
import { GebKlasse } from '../data/ws/dbKlassen/geb-klasse.model';
import { Tierkategorie } from '../data/ws/dbKlassen/tierkategorie.model';
import { ErgebnisseComponent } from '../components/pages/anwendung/ergebnisse/ergebnisse.component';
import { EinstellungenComponent } from '../components/pages/anwendung/einstellungen/einstellungen.component';
import { UserAuswahlGebaeude } from '../data/user/user-auswahl-gebaeude.model';
import { MainComponent } from '../components/pages/anwendung/main/main.component';
import { TableSelectKge } from '../data/table/table-select-kge.model';

@Injectable({
  providedIn: 'root'
}) 

export class LocalService {
  public mainComponentRef: BehaviorSubject<MainComponent | null> = new BehaviorSubject<MainComponent | null>(null);
  public ergebnisseComponentRef: BehaviorSubject<ErgebnisseComponent | null> = new BehaviorSubject<ErgebnisseComponent | null>(null);
  public einstellungenComponentRef: BehaviorSubject<EinstellungenComponent | null> = new BehaviorSubject<EinstellungenComponent | null>(null); 

  public kgeList: BehaviorSubject<Kge[]> = new BehaviorSubject<Kge[]>([]);
  public selectedKgeList: BehaviorSubject<TableSelectKge[]> = new BehaviorSubject<TableSelectKge[]>([]); 

  public preisstandList: BehaviorSubject<Preisstand[]> = new BehaviorSubject<Preisstand[]>([]); 
  public selectedPreisstand: BehaviorSubject<Preisstand> = new BehaviorSubject<Preisstand>(new Preisstand); 
  public preisfaktor: BehaviorSubject<number> = new BehaviorSubject<number>(1);   

  public diagramErgebnisse: BehaviorSubject<Ergebnisse | null> = new BehaviorSubject<Ergebnisse | null>(null); 





  public userGebaeudeFilter: BehaviorSubject<UserGebaeudeFilter | null> = new BehaviorSubject<UserGebaeudeFilter | null>(null);

  public modulAuspraegungPrFilter: BehaviorSubject<ModulAuspraegungPrFilter> = new BehaviorSubject<ModulAuspraegungPrFilter>(new ModulAuspraegungPrFilter());
  
  public selectedGebaeudeList: BehaviorSubject<Gebaeude[]> = new BehaviorSubject<Gebaeude[]>([]);
 
  public userGebaeudeFilterSubscription: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public isNewTierart: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public fromErgebnis: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public gebklasseList: BehaviorSubject<GebKlasse[]> = new BehaviorSubject<GebKlasse[]>([]);

  public tierkategorieList: BehaviorSubject<Tierkategorie[]> = new BehaviorSubject<Tierkategorie[]>([]);
 
  public foundGebaeudeList: BehaviorSubject<Gebaeude[]> = new BehaviorSubject<Gebaeude[]>([]);

  public selectedtierkategorieList: BehaviorSubject<Tierkategorie[]> = new BehaviorSubject<Tierkategorie[]>([]);

  public istGebaeude: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
 
  public userAuswahlGebaeude: BehaviorSubject<UserAuswahlGebaeude> = new BehaviorSubject<UserAuswahlGebaeude>(new UserAuswahlGebaeude());
}


